import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Header from "../../../components/Header";
import Firebase from "../../../firebasehelper";
import "./index.css";

const iPadBorder = require("../../../assets/media/DeveloperIntegration/iFrame/ipad-border.png");
const iPhoneBorder = require("../../../assets/media/DeveloperIntegration/iFrame/iphone-border.png");

class iFrame extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      brand_name: "",
      brand_url: "",
      demoUser: null,
      users: this.props.users,
      brand_data: this.props.brand_data,
      random: 0,
    };
  }
  componentDidMount() {
    const { brand_data } = this.state;
    console.log("brand_data", brand_data);
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      Firebase.getBrandDataByID(brand, async (brand_data) => {
        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          brand_name: brand_data.name,
        });
        let users = await Firebase.getAllUsersInBrand(brand_data.name);
        this.setState({ demoUser: users.find((obj) => obj.isDemo) });
      });
    }
  }
  copyText = (url) => {
    navigator.clipboard.writeText(url);
  };
  render() {
    const { username, role, logo, brand, demoUser, brand_name } = this.state;
    return (
      <div id="page-container">
        <Header username={username} role={role} logo={logo} brand={brand} />
        {demoUser && (
          <div id="main-container">
            <div className="demo-info">
              <div className="demo-user">
                <img
                  src={demoUser.avatar_url}
                  alt="Demo user avatar"
                  className="user-avatar"
                />
                Laura Demo User iFrame &nbsp;&nbsp;
                <p style={{ color: "lightgreen", marginBottom: 0 }}>
                  https://ecosystem.club/{brand_name.replace(/\s/g, "")}?uid=
                  <strong>{demoUser.id}</strong>
                </p>
              </div>
              <button
                className="btn copy-btn"
                onClick={() =>
                  this.copyText(
                    `https://ecosystem.club/${brand_name.replace(
                      /\s/g,
                      ""
                    )}?uid=${demoUser.id}`
                  )
                }
              >
                Copy link
              </button>
            </div>
            <p style={{ textAlign: "center" }}>
              Your iframe url remains constant with the UID interchanging. User
              UID is accessible via users & your brands private API. Your API
              controls back & forwards.
            </p>
            <div className="screenshot">
              <div className="ipad-screenshot">
                <img src={iPadBorder} className="ipad-border" />
                <iframe
                  src={`https://ecosystem.club/${brand_name.replace(
                    /\s/g,
                    ""
                  )}?uid=${demoUser.id}`}
                  key={this.state.random}
                  title={`iFrame of ${demoUser.firstname} on ${brand_name}`}
                  className="ipad-iframe"
                />
                <p className="ipad-link">
                  https://ecosystem.club/{brand_name.replace(/\s/g, "")}?uid=
                  <b>{demoUser.id}</b>
                </p>
              </div>
              <div className="iphone-screenshot">
                <img src={iPhoneBorder} className="iphone-border" />
                <iframe
                  src={`https://ecosystem.club/${brand_name.replace(
                    /\s/g,
                    ""
                  )}?uid=${demoUser.id}`}
                  title={`iFrame of ${
                    demoUser.firstname
                  } on ${brand_name.replace(/\s/g, "")}`}
                  className="iphone-iframe"
                />
                <p className="iphone-link">
                  https://ecosystem.club/{brand_name.replace(/\s/g, "")}?uid=
                  <b>{demoUser.id}</b>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    users: state.users,
    brand_data: state.brand_data,
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(iFrame));



// WEBPACK FOOTER //
// ./src/screens/DeveloperIntegration/Iframe/index.js